import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { BsInfoCircleFill, BsLinkedin, BsTwitter, BsX } from "react-icons/bs";
import { getTeamMembers } from "../../lib/contentful";
import { BLOCKS } from "@contentful/rich-text-types";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { SkeletonCard } from "../common/SkeletonCard";

const PresidentProfileContent = () => {
  const leadershipEngagements = [
    "Pioneer Chairman, ICAN Nsukka and District Society, 2017–2019.",
    "Assistant General Secretary, ICAN Eastern Zonal Districts, 2017–2019.",
    "Conference Accountant, ICAN Eastern Zonal Districts, 2018–2020.",
    "Member, ICAN District Societies Committee, 2017–2019.",
    "Member, ATSWA Examination Committee, ICAN, 2017/2018 Presidential Year.",
    "Member, ICAN Job Sourcing Committee, 2018/2019 Presidential Year.",
    "Board Member, ICAN Information Technology & Consulting Faculty, 2020–2022.",
    "Financial Secretary, ICAN Enugu and District Society Multi-Purpose Cooperative Society Limited, 2021–Date.",
    "Member, ICAN Information Technology Committee, 2022–2023.",
    "Member, ICAN Communication and Public Relations Committee, 2023–2024.",
    "Member, ICAN Board of Data and Information Technology Faculty, 2024–2025."
  ];

  const expertiseAreas = [
    "Strategic Financial Management",
    "Public-Sector and University Accounting",
    "Corporate Financial Reporting",
    "Budgeting and Financial Planning",
    "Internal Control and Risk Management",
    "Accounting Information Systems",
    "Financial Technology (FinTech)",
    "Digital Transformation",
    "Fraud Detection and Prevention",
    "Cooperative Financial Management",
    "Entrepreneurship and Business Incubation",
    "Professional Accounting Education",
    "Institutional Governance and Administration"
  ];

  return (
    <div className="president-profile-detail">
      {/* Overview Section */}
      <div className="team-modal-section">
        <h5 className="team-modal-section-title">Professional & Academic Qualifications</h5>
        <p className="team-modal-section-content">
          Dr. Stephen Ebialim Ndili, FCA is a distinguished accountant, financial management expert, university administrator, technology enthusiast, entrepreneur and professional leader with over two decades of professional accounting experience, including more than 17 years of specialised experience in university bursary administration.
        </p>
        <p className="team-modal-section-content">
          He currently serves as the Bursar of Alvan Ikoku Federal University of Education, Owerri, having been appointed the University's first substantive Bursar in June 2025. In this capacity, he provides strategic leadership for the University's financial management and administration, supporting institutional planning, financial reporting, budgeting, revenue management, expenditure control, accountability and overall financial sustainability.
        </p>
        <p className="team-modal-section-content">
          Dr. Ndili is a Fellow of the Institute of Chartered Accountants of Nigeria (FCA). His academic and professional qualifications reflect a strong combination of accounting, fraud detection, management, public finance, risk management and advanced business education.
        </p>
        <p className="team-modal-section-content">
          He holds an HND in Accountancy from the Institute of Management and Technology (IMT), Enugu, where he graduated with Upper Credit. He subsequently obtained a First-Class B.Sc. in Accounting and Fraud Detection from Achievers University, Owo, and a B.Sc. in Management from Ignatius Ajuru University of Education, Port Harcourt, where he graduated with Second Class Honours, Upper Division.
        </p>
        <p className="team-modal-section-content">
          He holds an M.Sc. and a Ph.D. in Accountancy from the University of Nigeria, Enugu Campus. He is a Chartered Public Finance Accountant (CPFA), UK, and a Full Member of the Chartered Institute of Loan and Risk Management of Nigeria (MILRM). He is currently pursuing a Doctor of Business Administration (DBA) in Financial Technology (FinTech) at the University of Nigeria Business School, Enugu Campus, as well as a B.Sc. in Cooperative and Rural Development with the National Open University of Nigeria.
        </p>
      </div>

      {/* Professional Career */}
      <div className="team-modal-section">
        <h5 className="team-modal-section-title">Professional Career</h5>
        <p className="team-modal-section-content">
          Dr. Ndili's professional career cuts across the private sector, telecommunications, manufacturing, accounting technology and the public university system.
        </p>
        <p className="team-modal-section-content">
          He began his career in 2004 with Survex Delivery Service, a courier company, before joining Ringo Telecoms Nigeria Limited in 2005 as an Account Officer. He rose to the position of Account Manager in 2006.
        </p>
        <p className="team-modal-section-content">
          Later in 2006, he joined Panar Limited, a manufacturing company, as Accounts Manager and System Administrator. His role provided an important foundation for his subsequent interest and expertise in accounting technology. He worked with accounting software developers, including Tally, and received practical training in accounting software design, administration, implementation and management.
        </p>
        <p className="team-modal-section-content">
          In March 2009, Dr. Ndili commenced his career in the public university system at the Federal University of Agriculture, Abeokuta, Ogun State. During his tenure, he acquired extensive experience across virtually all units and directorates of the University's Bursary Department and was also entrusted with the management of the University's customised accounting software.
        </p>
        <p className="team-modal-section-content">
          In August 2015, he joined the University of Nigeria, Nsukka, where he progressively rose through the ranks to become Senior Deputy Bursar/Director and served as Head of the Corporate Reporting Division. His responsibilities exposed him to high-level financial reporting, accounting operations, institutional financial management and corporate reporting within one of Nigeria's foremost universities.
        </p>
        <p className="team-modal-section-content">
          His career reached another significant milestone in June 2025 when he was appointed the first substantive Bursar of Alvan Ikoku Federal University of Education, Owerri.
        </p>
        <p className="team-modal-section-content">
          With experience spanning more than 20 years, Dr. Ndili has developed substantial expertise in financial management, public-sector accounting, university financial administration, corporate reporting, budgeting, financial reporting, internal controls, accounting information systems and digital transformation.
        </p>
        <p className="team-modal-section-content">
          He has worked with more than eight off-the-shelf and customised accounting software applications, giving him a distinctive understanding of the intersection between accounting, financial management and technology.
        </p>
      </div>

      {/* Entrepreneurship and Technology */}
      <div className="team-modal-section">
        <h5 className="team-modal-section-title">Entrepreneurship and Technology</h5>
        <p className="team-modal-section-content">
          Beyond his career in institutional financial management, Dr. Ndili is an accomplished entrepreneur, business incubator and technology-driven enterprise promoter.
        </p>
        <p className="team-modal-section-content">
          He served as Managing Partner/Chief Executive Officer of Bright Minds Associate, an ICAN tuition centre established in 2011. Through this platform, he contributed to professional accounting education, mentoring and the development of aspiring accounting professionals.
        </p>
        <p className="team-modal-section-content">
          He is also the Founder and President of Lion Multi-Purpose Cooperative Society Limited, a technology-driven cooperative initiative established in September 2021. Under his leadership, the cooperative has experienced remarkable growth, expanding from an initial membership of 36 members in September 2021 to more than 1,450 members as of September 2026, with an asset base exceeding ₦1.5 billion within five years. His involvement in cooperative development reflects his broader commitment to financial inclusion, wealth creation, entrepreneurship, digital transformation and shared prosperity.
        </p>
      </div>

      {/* Professional Leadership and Service */}
      <div className="team-modal-section">
        <h5 className="team-modal-section-title">Professional Leadership and Service</h5>
        <p className="team-modal-section-content">
          Dr. Ndili has demonstrated a strong commitment to professional leadership and service, particularly within the Institute of Chartered Accountants of Nigeria (ICAN). Among his notable professional leadership and service engagements are:
        </p>
        <ul className="list-unstyled mb-3 ps-1">
          {leadershipEngagements.map((item, index) => (
            <li key={index} className="d-flex align-items-start gap-2 mb-2">
              <span style={{ color: 'var(--primary)', fontWeight: 'bold' }}>•</span>
              <span className="team-modal-section-content mb-0">{item}</span>
            </li>
          ))}
        </ul>
        <p className="team-modal-section-content">
          Through these assignments, he has contributed to professional development, institutional governance, accounting education, technology advancement, member engagement and the strengthening of the accountancy profession.
        </p>
      </div>

      {/* Areas of Expertise */}
      <div className="team-modal-section">
        <h5 className="team-modal-section-title">Areas of Expertise</h5>
        <p className="team-modal-section-content">
          Dr. Ndili's professional interests and areas of expertise include:
        </p>
        <div className="row g-2 mb-2">
          {expertiseAreas.map((area, index) => (
            <div key={index} className="col-12 col-md-6">
              <div 
                className="p-2 rounded d-flex align-items-center gap-2"
                style={{ background: '#f8fafc', border: '1px solid #e2e8f0' }}
              >
                <span style={{ color: 'var(--primary)', fontWeight: 'bold', fontSize: '0.85rem' }}>✓</span>
                <span className="small fw-semibold" style={{ color: '#334155' }}>{area}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Professional Development */}
      <div className="team-modal-section">
        <h5 className="team-modal-section-title">Professional Development</h5>
        <p className="team-modal-section-content">
          Dr. Ndili has attended and participated in numerous national and international conferences, seminars, workshops and professional development programmes, continually expanding his knowledge in accounting, finance, management, technology, public-sector administration, risk management and related disciplines.
        </p>
        <p className="team-modal-section-content">
          His professional journey reflects a rare combination of academic excellence, practical accounting experience, institutional leadership, technology orientation and entrepreneurial initiative.
        </p>
      </div>

      {/* Personal Philosophy */}
      <div className="team-modal-section">
        <h5 className="team-modal-section-title">Personal Philosophy</h5>
        <p className="team-modal-section-content">
          Dr. Ndili is passionate about excellence, innovation, accountability, institutional transformation, capacity development, financial sustainability and the responsible application of technology to improve organisational performance.
        </p>
        <p className="team-modal-section-content">
          His career is characterised by a commitment to continuous learning, professional service and the creation of sustainable value for institutions, professional organisations and communities.
        </p>
        <p className="team-modal-section-content fw-semibold" style={{ color: '#096c3a' }}>
          He is married and blessed with children.
        </p>
      </div>
    </div>
  );
};

export const Team = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleShowModal = (member) => {
    setSelectedMember(member);
    setShowModal(true);
  };

  const handleHideModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const members = await getTeamMembers();
        const updated = members.map((m) => {
          const isPresident =
            Boolean(m.name &&
            m.name.toUpperCase().includes("STEPHEN") &&
            m.name.toUpperCase().includes("NDILI"));

          if (isPresident) {
            return {
              ...m,
              name: "STEPHEN EBIALIM NDILI",
              qualification: "Ph.D., M.Sc., B.Sc., HND, FCA, CPFA, MILRM",
              position: "President",
              image: "img/president_steve.png",
              customContent: <PresidentProfileContent />
            };
          }
          return m;
        });
        setTeamMembers(updated);
      } catch (error) {
        console.error("Error fetching team members:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const options = {
    renderNode: {
      [BLOCKS.HEADING_2]: (node, children) => (
        <h5 className="team-modal-section-title">{children}</h5>
      ),
      [BLOCKS.PARAGRAPH]: (node, children) => (
        <p className="team-modal-section-content">{children}</p>
      ),
    },
  };

  if (loading) {
    return (
      <div id="team" className="container py-5">
        <div className="row g-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <SkeletonCard key={i} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div id="team" className="py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 mb-5 text-center">
            <h2 className="display-4 fw-bold mb-4">Meet the Team</h2>
            <div className="title-underline mb-4"></div>
            <p className="lead text-muted">
              Every successful organization is built on so many factors but the
              most significant factor is human resource. Our success thus far is
              anchored on enthusiastic, creative, energetic and productive team
              made up of professionals from various fields of endeavour. Amongst
              our team are professionals and Chartered Accountants with industry
              experience, a seasoned legal practitioner and experienced
              lecturers from the academia. We have over time struck a balance in
              opinions on the best options that are more suitable to our idea of
              proposing an innovative way of enhancing cooperative society
              services.
            </p>
            <p className="fw-bold mt-3">
              Therefore, we are glad to oblige you the profiles of our pioneer
              Management Committee:
            </p>
          </div>
        </div>

        <div className="row g-4">
          {teamMembers.map((member, i) => (
            <div key={`${member.name}-${i}`} className="col-lg-4 col-md-6 col-sm-12 mb-4">
              <div className="team-card">
                <div className="team-image-wrapper">
                  <img 
                    src={member.image} 
                    alt={member.name} 
                    className="team-img" 
                    onError={(e) => {
                      if (member.name && member.name.toUpperCase().includes("STEPHEN")) {
                        e.target.src = "img/president_steve.jpg";
                      }
                    }}
                  />
                  <div className="team-overlay">
                    <div className="team-social">
                      <a href="#linkedin" className="social-link">
                        <BsLinkedin />
                      </a>
                      <a href="#twitter" className="social-link">
                        <BsTwitter />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="team-info">
                  <h4 className="team-name">{member.name}</h4>
                  <p className="team-title">{member.qualification}</p>
                  <p className="team-position">{member.position}</p>
                  <button
                    type="button"
                    className="team-info-btn"
                    onClick={() => handleShowModal(member)}
                  >
                    <BsInfoCircleFill className="me-2" /> View Profile
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <TeamInfoModal
        showModal={showModal}
        handleHideModal={handleHideModal}
        member={selectedMember}
        options={options}
      />
    </div>
  );
};

const TeamInfoModal = ({ showModal, handleHideModal, member, options }) => {
  if (!member) return null;

  return (
    <Modal
      size="lg"
      show={showModal}
      onHide={handleHideModal}
      contentClassName="custom-modal-content"
      centered
      aria-labelledby="team-member-modal"
    >
      <div className="team-modal-header">
        <button
          className="team-modal-close"
          onClick={handleHideModal}
          aria-label="Close modal"
        >
          <BsX />
        </button>
      </div>

      <div className="team-modal-body">
        <div className="row g-4">
          <div className="col-lg-4 text-center">
            <div className="team-modal-profile">
              <div className="team-modal-image-container">
                <img
                  src={member.image}
                  alt={member.name}
                  className="team-modal-image"
                  onError={(e) => {
                    if (member.name && member.name.toUpperCase().includes("STEPHEN")) {
                      e.target.src = "img/president_steve.jpg";
                    }
                  }}
                />
              </div>
              <h4 className="team-modal-name">{member.name}</h4>
              <p className="team-modal-qualifications">{member.qualification}</p>
              <div className="team-modal-position">
                <span>{member.position}</span>
              </div>
              <div className="team-modal-social mt-3">
                <a href="#linkedin" className="social-link-modal">
                  <BsLinkedin />
                </a>
                <a href="#twitter" className="social-link-modal">
                  <BsTwitter />
                </a>
              </div>
            </div>
          </div>

          <div className="col-lg-8">
            <div className="team-modal-content" style={{ maxHeight: '650px', overflowY: 'auto', paddingRight: '8px' }}>
              {member.customContent ? (
                member.customContent
              ) : member.sections ? (
                documentToReactComponents(member.sections, options)
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default Team;
